import React, { useMemo }  from 'react';
import { useSelector, shallowEqual } from "react-redux";
import { RootState } from "../services/rootReducer";
import { calRangeType, selectCalendarRange } from "../services/View_Slice";
import { Container } from 'rsuite';
import logger from '../loggers/logger';
import { format, parseISO } from 'date-fns';
import CalendarComp from "./calendar/CalendarComp";
import styles from "./css/CalendarView.module.css";

interface Dictionary<T> {
    [Key: string]: T;
  }

type screenValues = {
  mobile: boolean,
  width: number
}

function CalendarView(props: React.PropsWithChildren<screenValues>) {
const { calRangeUsed, calRangeValue } = useSelector(selectCalendarRange);
const result = useSelector((state: RootState) => state.Query.result);

// Memoize event list construction — only rebuild when query result changes
const theEvents = useMemo(() => {
  const events: Array<any> = [];
  var docs: Array<Dictionary<string>> = [];
  if(result!==undefined && result["numFound"] !== undefined){
    docs = result["docs"];
  }
  var n=0;
  for (var aDoc in docs) {
    try {
      const fileModified = docs[aDoc]['file_modified_dt'];
      const dateStr =
        typeof fileModified === 'string'
          ? fileModified.replace(/T.*$/, '')
          : new Date(fileModified).toISOString().replace(/T.*$/, '');

      const extProps: Dictionary<string> = {
        anId: String(n),
        aColor: '#fd89400',
        filename: `${n}: ${docs[aDoc]['filename_ss']}`,
      };

      const anitem: Dictionary<string | Dictionary<string>> = {
        id: String(n),
        title: docs[aDoc]['mission_ss'],
        start: dateStr,
        extendedProps: extProps,
      };

      events.push(anitem);
      n++;
    } catch (error) {
      console.error("Error processing document index " + aDoc, error);
    }
  }
  return events;
}, [result]);

// Memoize date calculation — only recalculate when calRangeUsed/calRangeValue change
const anotherDate = useMemo(() => {
  var adate: Date | undefined = undefined;

  if(calRangeUsed !== undefined){
    switch(calRangeUsed){
        case calRangeType.month:
            adate = parseISO(String(calRangeValue+"-01"));
            break;
        case calRangeType.year:
            adate = parseISO(String(calRangeValue+"-01-01"));
            break;
        case calRangeType.week:
            adate = parseISO(String(calRangeValue));
            break;
        default:
            break;
    }
  }

  var anInitialDate: string = "";
  if(adate!==undefined){
      anInitialDate = format(adate, 'yyyy-MM-dd');
  }else{
      anInitialDate = format(new Date(), 'yyyy-MM-dd');
  }
  return parseISO(anInitialDate);
}, [calRangeUsed, calRangeValue]);

    return (
        <Container className={styles.container}>
            <CalendarComp startDate={anotherDate} endDate={anotherDate} events={theEvents} mobile={props.mobile} width={props.width}/>
        </Container>
    )

}

export default React.memo(CalendarView);